import { Box } from "@mui/material";
import { useState } from "react";
import Text from "../text/Text";
import { dates as dateLabel } from "../messages";
import moment from "moment-timezone";
import CustomDatePicker from ".";
import { isValidDate, minDateYear } from "../constants";
import AlertMessage from "../alertMessage/AlertMessage";
import { useSession } from "../../hooks/useSession";

function CustomDateRangePicker({ formik, showDateLabel = true }) {
  const { session } = useSession();
  const [disableFilterStartDate, setDisableFilterStartDate] = useState();
  const [disableFilterEndDate, setDisableFilterEndDate] = useState();

  const { touched, errors, setTouched, values, setFieldValue } = formik;
  const userDateFormat =
    session?.user?.date_format?.toUpperCase() || "DD/MM/YYYY";

  const handleFilterDateChange = (momentDateObj, setDisableDate) => {
    if (isValidDate(momentDateObj)) {
      setDisableDate(moment(momentDateObj));
    } else {
      setDisableDate();
    }
  };

  const filterDatePickerElement = (
    labelText,
    dateValueType,
    setDisableDate
  ) => {
    const dateTimezone = moment.tz.guess();

    // Convert timestamp to moment object for DatePicker display
    const dateValue = values[dateValueType]
      ? typeof values[dateValueType] === "number"
        ? moment(values[dateValueType])
        : values[dateValueType]
      : null;

    const customProps = {
      disableFuture: true,
      minDate: minDateYear,
      value: dateValue,
      setValue: (value) => {
        // Convert moment object to timestamp (number) for storage
        const timestamp = value ? moment(value).valueOf() : null;
        setFieldValue(dateValueType, timestamp);
      },
      handleDateChange: (momentObj) =>
        handleFilterDateChange(momentObj, setDisableDate),
      onBlur: () => setTouched({ ...touched, [dateValueType]: true }),
      format: userDateFormat,
    };

    if (dateTimezone) {
      customProps.timezone = dateTimezone;
    }

    if (dateValueType === "start_at") {
      customProps.maxDate = disableFilterEndDate;
    }

    if (dateValueType === "end_at") {
      customProps.minDate = disableFilterStartDate || minDateYear;
    }

    return (
      <Box className="account-date-picker ">
        <Text
          className="grey-text input-with-dropdown-label"
          font="regular"
          size={14}
          sx={{ flex: 1 }}
          variant="h6"
        >
          {labelText}
        </Text>
        <CustomDatePicker {...customProps} />
      </Box>
    );
  };
  return (
    <Box className="custom-date-range-wrapper">
      {showDateLabel && (
        <Text
          className="default-text"
          size={16}
          font="bold"
          sx={{ marginBottom: "16px" }}
        >
          {dateLabel}
        </Text>
      )}
      <Box className="date-picker">
        {filterDatePickerElement(
          "Start date",
          "start_at",
          setDisableFilterStartDate
        )}
        {touched?.start_at && Boolean(errors?.start_at) && (
          <AlertMessage
            severity="error"
            message={errors?.start_at}
            sx={{ marginBottom: "8px" }}
          />
        )}
        {filterDatePickerElement("End date", "end_at", setDisableFilterEndDate)}

        {touched?.end_at && Boolean(errors?.end_at) && (
          <AlertMessage
            className="margin-top14"
            severity="error"
            message={errors?.end_at}
          />
        )}
      </Box>
    </Box>
  );
}

export default CustomDateRangePicker;
